
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/roles",
      function () {
        return require("private-next-pages/roles.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/roles"])
      });
    }
  